import { Injectable, signal } from '@angular/core';

/**
 * Global signal that any component can set to trigger the auth modal.
 * The budget component (which owns the modal) subscribes to this.
 */
@Injectable({ providedIn: 'root' })
export class AuthPromptService {
  readonly showPrompt = signal(false);

  prompt(): void {
    this.showPrompt.set(true);
  }
}
